<script>
import { mapState, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import { id } from "vuejs-datepicker/dist/locale";

export default {
	name: "jumlahKrisma",
	components: { Datepicker },
	data() {
		return {
			kriteria: {},
			jk: {},
			loading: true,
			formData: { tahun: new Date() },
			filterDateLang: id,
		};
	},
	created() {
		this.findAll();
	},
	mounted() {},
	computed: {
		...mapState({
			myData: (state) => state.laporan.data,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	methods: {
		...mapActions({
			getJumlahKrisma: "laporan/getJumlahKrisma",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		async findAll() {
			await this.getJumlahKrisma(this.formData).then((response) => {
				this.kriteria = response.kriteria;
				this.jk = response.jk;
				console.log(response);
			});
		},
		refreshData() {
			this.findAll();
		},
		onChangeJenis() {
			this.findAll();
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Laporan Jumlah Krisma" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<!-- --------------------------- /FILTER --------------------------- -->

				<div class="card-body">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Tahun</label>
								<datepicker
									v-model="formData.tahun"
									input-class="datepicker-here form-control form-control-sm"
									:minimumView="'year'"
									:maximumView="'year'"
									format="yyyy"
									:language="filterDateLang"
									@input="onChangeJenis($event)"
									required
								></datepicker>
							</div>
						</div>
					</div>
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<div class="row">
							<div class="col-md-6">
								<div class="table-responsive invoice-table">
									<table class="table table-bordered table-striped">
										<thead class="thead-light">
											<tr>
												<th class="text-left">TAHUN</th>
												<th class="text-right">JUMLAH</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Dibawah 1 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria1 }}
												</td>
											</tr>
											<tr>
												<td>1 - 7 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria2 }}
												</td>
											</tr>
											<tr>
												<td>7 - 21 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria3 }}
												</td>
											</tr>
											<tr>
												<td>Diatas 21 tahun</td>
												<td class="text-right">
													{{ kriteria.kriteria4 }}
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td>TOTAL</td>
												<td class="text-right">
													{{
														kriteria.kriteria1 +
														kriteria.kriteria2 +
														kriteria.kriteria3 +
														kriteria.kriteria4
													}}
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
							<div class="col-md-6">
								<div class="table-responsive invoice-table">
									<table class="table table-bordered table-striped">
										<thead class="thead-light">
											<tr>
												<th class="text-left">JK</th>
												<th class="text-right">JUMLAH</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Laki-laki</td>
												<td class="text-right">
													{{ jk.l }}
												</td>
											</tr>
											<tr>
												<td>Perempuan</td>
												<td class="text-right">
													{{ jk.p }}
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td>TOTAL</td>
												<td class="text-right">
													{{ jk.p + jk.l }}
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.table tfoot {
	background-color: #212529;
}
.table tfoot td {
	color: #fff;
}

.table {
	font-size: 12px !important;
}

.table th,
.table td {
	padding: 0.5rem;
}
</style>